// React
import { PropsWithChildren, createContext, useEffect, useRef } from "react"

// Form
import { useFormContext, useWatch } from "react-hook-form"

// Types
import type { LocationProductType } from "../types"

// Utils
import { type FormType, type LocationProductFilters, useLocationProduct } from "../utils"

export const LocationProductContext = createContext<{
  data: LocationProductType[]
  isLoading: boolean
  refetchWithFilters: (filters?: LocationProductFilters) => void
}>({
  data: [],
  isLoading: false,
  refetchWithFilters: () => undefined
})

export function LocationProductProvider(params: PropsWithChildren<{}>): JSX.Element {
  // Form
  const { control } = useFormContext<FormType>()
  const location_id: string = useWatch({
    control,
    name: "location_id"
  })
  const transaction_date: string = useWatch({
    control,
    name: "transaction_date"
  })

  // Hooks
  const { data, isLoading, refetch } = useLocationProduct()

  const locationRef = useRef(location_id)
  const dateRef = useRef(transaction_date)
  locationRef.current = location_id
  dateRef.current = transaction_date

  useEffect(() => {
    if (location_id && transaction_date) {
      refetch(location_id, transaction_date)
    }
  }, [location_id, transaction_date, refetch])

  const refetchWithFilters = (filters?: LocationProductFilters) => {
    if (locationRef.current && dateRef.current) {
      refetch(locationRef.current, dateRef.current, filters)
    }
  }

  return (
    <LocationProductContext.Provider
      value={{
        data,
        isLoading,
        refetchWithFilters
      }}
    >
      {params.children}
    </LocationProductContext.Provider>
  )
}